//Fixed Param
export const FHIRResourceParamType_Fixed = 'fixed';
//Dynamic Param
export const FHIRResourceParamType_Dynamic = 'dynamic';
export const FHIRResourceParamTypes = [FHIRResourceParamType_Fixed, FHIRResourceParamType_Dynamic];
//# sourceMappingURL=types.js.map